import {ApplicationsAndCrLineStatuses} from "@/types_and_interfaces/enums.ts";

export const invalid_style = "1px solid #EB4630"

export const country_code = "+373"

export const kyc_processing_timeout = 15000

export const promocode_enabled:boolean = false

export const application_keys: ApplicationsAndCrLineStatuses[] = [
    ApplicationsAndCrLineStatuses.approved_and_payment_pending,
    ApplicationsAndCrLineStatuses.approved_and_need_sign,
    ApplicationsAndCrLineStatuses.approved_and_not_valid_data,
    ApplicationsAndCrLineStatuses.approved_and_checked,
    ApplicationsAndCrLineStatuses.approved_and_received,
    ApplicationsAndCrLineStatuses.more_data_and_not_verified,
    ApplicationsAndCrLineStatuses.approved_and_not_verified,
    ApplicationsAndCrLineStatuses.more_data_and_verified,
    ApplicationsAndCrLineStatuses.pending_approval,
    ApplicationsAndCrLineStatuses.pending_submission,
    ApplicationsAndCrLineStatuses.approved,
    ApplicationsAndCrLineStatuses.disbursed,
    ApplicationsAndCrLineStatuses.submitting,
    ApplicationsAndCrLineStatuses.unknown,
    ApplicationsAndCrLineStatuses.transmission_error,
    ApplicationsAndCrLineStatuses.failed,
    ApplicationsAndCrLineStatuses.canceled,
    ApplicationsAndCrLineStatuses.closed,
    // ApplicationsAndCrLineStatuses.rejected,
    ApplicationsAndCrLineStatuses.loan_already_exist,
];

export const spare_phone_number = "022 838 888"

export const face_liveness_dictionary = {
    // use default strings for english
    ro: {
        photosensitivyWarningHeadingText: 'Avertizare de fotosensibilitate',
        photosensitivyWarningBodyText:
            'Această verificare emite diferite culori. Aveți grijă dacă sunteți fotosensibil.',
        goodFitCaptionText: 'Potrivit',
        tooFarCaptionText: 'Prea departe',
        
        hintCenterFaceText: 'Centrați-vă fața',
        startScreenBeginCheckText: 'Începe verificarea',
        
        cameraMinSpecificationsHeadingText:
            'Camera nu îndeplinește specificațiile minime',
        cameraMinSpecificationsMessageText:
            'Camera trebuie să accepte cel puțin o rezoluție de 320*240 și 15 cadre pe secundă..',
        cameraNotFoundHeadingText: 'Camera nu este accesibilă.',
        cameraNotFoundMessageText:
            'Verificați dacă o cameră este conectată și că nu există altă aplicație care să utilizeze camera. Poate fi necesar să accesați setări pentru a acorda permisiuni camerei și să închideți toate instanțele browserului și să încercați din nou.',
        a11yVideoLabelText: 'Cameră web pentru verificarea vieții',
        cancelLivenessCheckText: 'Anulați verificarea Liveness',
        goodFitAltText:
            "Ilustrație a feței unei persoane, care se potrivește perfect în interiorul unui oval.",
        hintCenterFaceInstructionText:
            'Instrucțiuni: înainte de a începe verificarea, asigurați-vă că camera dvs. se află în centrul de sus a ecranului și centrați-vă fața pe cameră. Când începe verificarea, un oval va apărea în centru. Vi se va cere să treceți înainte în oval și apoi să rămâneți nemișcat. După ce stați nemișcat câteva secunde, ar trebui să auziți verificarea finalizată.',
        hintFaceOffCenterText:
            'Fața nu este în oval, centrați-vă fața pe cameră.',
        hintMoveFaceFrontOfCameraText: 'Mutați fața în fața camerei',
        hintTooManyFacesText: 'Asigurați-vă că doar o singură față este în fața camerei',
        hintFaceDetectedText: 'Fața detectată',
        hintCanNotIdentifyText: 'Mutați fața în fața camerei',
        hintTooCloseText: 'Mișcă-te înapoi',
        hintTooFarText: 'Vino mai aproape',
        hintConnectingText: 'Se conectează...',
        
        hintVerifyingText: 'Verificare...',
        hintCheckCompleteText: 'Verificare completă',
        hintIlluminationTooBrightText: 'Mutați-vă într-o zonă mai întunecată',
        hintIlluminationTooDarkText: 'Mutați-vă într-o zonă mai luminoasă',
        hintIlluminationNormalText: 'Condiții normale de iluminare',
        hintHoldFaceForFreshnessText: 'Stați nemișcat',
        hintMatchIndicatorText: '50% completat. Apropiați-vă mai mult.',
        photosensitivityWarningBodyText: 'Această verificare folosește culori diferite. Fiți atent dacă sunteți fotosensibil.',
        photosensitivityWarningHeadingText: 'Avertisment de fotosensibilitate',
        photosensitivityWarningInfoText: 'Unele persoane pot experimenta crize epileptice când sunt expuse la lumini colorate. Fiți atent dacă dumneavoastră sau cineva din familia dumneavoastră suferă de epilepsie.',
        photosensitivityWarningLabelText: 'Mai multe informații despre fotosensibilitate',
        photosensitivyWarningInfoText: 'Unele persoane pot experimenta crize epileptice când sunt expuse la lumini colorate. Fiți atent dacă dumneavoastră sau cineva din familia dumneavoastră suferă de epilepsie.',
        photosensitivyWarningLabelText: 'Mai multe informații despre fotosensibilitate',
        retryCameraPermissionsText: 'Reîncercați',
        recordingIndicatorText: 'Înregistrare',
        tooFarAltText: "Ilustrație a feței unei persoane într-un oval; există o distanță între perimetrul feței și limitele ovalei.",
        waitingCameraPermissionText: 'Se așteaptă permisiunea pentru cameră.',
        
        errorLabelText: "Eroare",
        connectionTimeoutHeaderText: "Conexiune expirată",
        connectionTimeoutMessageText: "Conexiunea a expirat.",
        timeoutHeaderText: "Expirat",
        timeoutMessageText: "Fața nu a încăput în oval în limita de timp. Încercați din nou și umpleți complet ovalul cu fața în el.",
        faceDistanceHeaderText: "Detectată mișcare înainte",
        faceDistanceMessageText: "Evitați să vă apropiați când vă conectați.",
        multipleFacesHeaderText: "Detectate mai multe fețe",
        multipleFacesMessageText: "Asigurați-vă că în fața camerei se află doar o singură față când vă conectați.",
        clientHeaderText: "Eroare de client",
        clientMessageText: "Verificarea a eșuat din cauza unei probleme de client",
        serverHeaderText: "Problemă de server",
        serverMessageText: "Nu se poate finaliza verificarea din cauza unei probleme de server",
        landscapeHeaderText: "Nu este suportată orientarea peisaj",
        landscapeMessageText: "Rotiți dispozitivul în orientare portret (verticală).",
        portraitMessageText: "Asigurați-vă că dispozitivul rămâne în orientare portret (verticală) pe durata verificării.",
        tryAgainText: "Încercați din nou"
    },
    ru: {
        photosensitivyWarningHeadingText: 'Предупреждение о светочувствительности',
        photosensitivyWarningBodyText:
            'Эта проверка мигает разными цветами. Будьте осторожны, если вы светочувствительны.',
        goodFitCaptionText: 'Хорошо',
        tooFarCaptionText: 'Слишком далеко',
        hintCenterFaceText: 'Центрируйте свое лицо',
        startScreenBeginCheckText: 'Начата проверка',
        
        cameraMinSpecificationsHeadingText:
            'Камера не соответствует минимальным техническим характеристикам',
        cameraMinSpecificationsMessageText:
            'Камера должна поддерживать разрешение не менее 320*240 и частоту 15 кадров в секунду.',
        cameraNotFoundHeadingText: 'Камера недоступна.',
        cameraNotFoundMessageText:
            'Убедитесь, что камера подключена и ее не использует другое приложение. Возможно, вам придется зайти в настройки, чтобы предоставить разрешения камере, закрыть все экземпляры браузера и повторить попытку.',
        a11yVideoLabelText: 'Веб-камера для проверки работоспособности',
        cancelLivenessCheckText: 'Отменить проверку работоспособности',
        goodFitAltText:
            "Иллюстрация лица человека, идеально вписывающегося в овал.",
        hintCenterFaceInstructionText:
            'Инструкция: Прежде чем начать проверку, убедитесь, что ваша камера находится в центре верхней части экрана, а ваше лицо находится по центру камеры. Когда проверка начнется, в центре появится овал. Вам будет предложено двигаться вперед в овал, а затем будет предложено остаться на месте. Подержав неподвижно в течение нескольких секунд, вы должны услышать, что проверка завершена.',
        hintFaceOffCenterText:
            'Лицо не в овале, расположите лицо по центру камеры.',
        hintMoveFaceFrontOfCameraText: 'Переместить лицо перед камерой',
        hintTooManyFacesText: 'Убедитесь, что перед камерой находится только одно лицо',
        hintFaceDetectedText: 'Обнаружено лицо',
        hintCanNotIdentifyText: 'Переместить лицо перед камерой',
        hintTooCloseText: 'Назад',
        hintTooFarText: 'Подойдите ближе',
        hintConnectingText: 'Подключение...',
        
        
        hintVerifyingText: 'Проверка...',
        hintCheckCompleteText: 'Проверка завершена',
        hintIlluminationTooBrightText: 'Переместитесь в более темную зону',
        hintIlluminationTooDarkText: 'Переместитесь в более светлую зону',
        hintIlluminationNormalText: 'Нормальные условия освещения',
        hintHoldFaceForFreshnessText: 'Держите лицо неподвижно',
        hintMatchIndicatorText: 'Завершено 50%. Приближайтесь еще ближе.',
        photosensitivityWarningBodyText: 'Эта проверка использует разные цвета. Будьте осторожны, если у вас фотосенситивность.',
        photosensitivityWarningHeadingText: 'Предупреждение о фоточувствительности',
        photosensitivityWarningInfoText: 'Некоторые люди могут испытывать эпилептические припадки при воздействии цветных светов. Будьте осторожны, если у вас или кого-либо из вашей семьи есть эпилепсия.',
        photosensitivityWarningLabelText: 'Дополнительная информация о фоточувствительности',
        photosensitivyWarningInfoText: 'Некоторые люди могут испытывать эпилептические припадки при воздействии цветных светов. Будьте осторожны, если у вас или кого-либо из вашей семьи есть эпилепсия.',
        photosensitivyWarningLabelText: 'Дополнительная информация о фоточувствительности',
        retryCameraPermissionsText: 'Повторить',
        recordingIndicatorText: 'Запись',
        tooFarAltText: 'Иллюстрация лица человека в овале; есть промежуток между периметром лица и границами овала.',
        waitingCameraPermissionText: 'Ожидание разрешения на использование камеры.',
        
        errorLabelText: "Ошибка",
        connectionTimeoutHeaderText: "Таймаут подключения",
        connectionTimeoutMessageText: "Время подключения истекло.",
        timeoutHeaderText: "Таймаут",
        timeoutMessageText: "Лицо не поместилось в овал в установленное время. Попробуйте ещё раз и полностью заполните овал лицом.",
        faceDistanceHeaderText: "Обнаружено движение вперёд",
        faceDistanceMessageText: "Избегайте приближения при подключении.",
        multipleFacesHeaderText: "Обнаружено несколько лиц",
        multipleFacesMessageText: "Убедитесь, что перед камерой находится только одно лицо при подключении.",
        clientHeaderText: "Ошибка клиента",
        clientMessageText: "Проверка не удалась из-за проблемы с клиентом",
        serverHeaderText: "Проблема с сервером",
        serverMessageText: "Невозможно завершить проверку из-за проблемы с сервером",
        landscapeHeaderText: "Не поддерживается альбомная ориентация",
        landscapeMessageText: "Поверните устройство в портретную (вертикальную) ориентацию.",
        portraitMessageText: "Убедитесь, что ваше устройство остаётся в портретной (вертикальной) ориентации на время проверки.",
        tryAgainText: "Попробуйте снова"
    },
};

export const items_on_page = 6
export const penalty_amount = 0.8

export const notification_scope = {
    LoanSyncStatus: "LOAN_SYNC_STATUS",
    IdentityCardProcessing: "IDENTITY_CARD_PROCESSING",
    LivenessProcessing: "LIVENESS_PROCESSING",
    FirstPhotoComparisonProcessing: "FIRST_PHOTO_COMPARISON_PROCESSING",
    SecondPhotoComparisonProcessing: "SECOND_PHOTO_COMPARISON_PROCESSING",
    CreditLineTransaction: "CREDIT_LINE_TRANSACTION",
    CreditLineTransactionStatusSync: "CREDIT_LINE_TRANSACTION_STATUS_SYNC",
    LoanInstallment: "LOAN_INSTALLMENT",
    ResetKYC: "RESET_KYC",
    ExpireKYC: "EXPIRE_KYC",
    ASPConflict: "ASP_CONFLICT"
}

export const notification_type = {
    IdentityCardPassed: "IDENTITY_CARD_PASSED",
    LivenessPassed: "LIVENESS_PASSED",
    FirstFaceComparisonPassed: "FIRST_FACE_COMPARISON_PASSED",
    IdentityCardFailed: "IDENTITY_CARD_FAILED",
    LivenessFailed: "LIVENESS_FAILED",
    FirstFaceComparisonFailed: "FIRST_FACE_COMPARISON_FAILED",
    LoanStatusChanged: "LOAN_STATUS_CHANGED",
    ContractSignSuccessful: "CONTRACT_SIGN_SUCCESSFUL",
    CreditLineTransactionStatusChanged: "CREDIT_LINE_TRANSACTION_STATUS_CHANGED",
    IdentityCardOneMoreAttempt: "IDENTITY_CARD_ONE_MORE_ATTEMPT",
    LivenessOneMoreAttempt: "LIVENESS_ONE_MORE_ATTEMPT",
    LoanStatusChangedNotValid: "LOAN_STATUS_CHANGED_NOT_VALID",
    ResetKYC: "RESET_KYC",
    LoanStatusRejected: "LOAN_STATUS_REJECTED",
    ExpireKYC30Days: "EXPIRE_KYC_30_DAYS",
    ExpireKYC20Days: "EXPIRE_KYC_20_DAYS",
    ExpireKYC10Days: "EXPIRE_KYC_10_DAYS",
    ExpireKYC5Days: "EXPIRE_KYC_5_DAYS",
    ExpireKYC3Days: "EXPIRE_KYC_3_DAYS",
    ExpireKYC2Days: "EXPIRE_KYC_2_DAYS",
    ExpireKYC1Days: "EXPIRE_KYC_1_DAYS",
    ASPKYCConflict: "ASP_KYC_CONFLICT",
    AdminCustomNotification: "ADMIN_CUSTOM_NOTIFICATION"
}